<template>
    <div>
        <label v-if="label" class="form-label">{{ label }}:</label>

        <div class="flex items-center">
            <div v-if="previewImg" class="mr-3" style="width: 80px; height:80px;">
                <div
                    class="rounded-lg w-full h-full"
                    v-bind:style="{
                        'background-image': 'url(' + previewImg + ')',
                        'background-size': 'cover',
                        'background-position': 'center'
                    }"
                ></div>
            </div>

            <div class="form-input p-0" :class="{ error: errors.length }">
                <input ref="file" type="file" :accept="accept" class="hidden" @change="change" />
                <div v-if="!value" class="p-2">
                    <button type="button" class="px-4 py-1 bg-teal-600 hover:bg-teal-800 rounded-sm text-xs font-medium text-white" @click="browse">
                        Browse
                    </button>
                </div>
                <div v-else class="flex items-center justify-between p-2">
                    <div class="flex-1 pr-1">
                        {{ value.name }} <span class="text-gray-800 text-xs">({{ filesize(value.size) }})</span>
                    </div>
                    <button type="button" class="px-4 py-1 bg-teal-600 hover:bg-teal-800 rounded-sm text-xs font-medium text-white" @click="remove">
                        Remove
                    </button>
                </div>
            </div>
            <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: File,
        label: String,
        accept: String,
        errors: {
            type: Array,
            default: () => []
        },
        dataPreviewImg: String
    },
    data: function() {
        return {
            previewImg: this.dataPreviewImg,
            previewFilename: ""
        };
    },
    watch: {
        value(value) {
            if (!value) {
                this.$refs.file.value = "";
            }
        }
    },
    methods: {
        filesize(size) {
            var i = Math.floor(Math.log(size) / Math.log(1024));
            return (size / Math.pow(1024, i)).toFixed(2) * 1 + " " + ["B", "kB", "MB", "GB", "TB"][i];
        },
        browse() {
            this.$refs.file.click();
        },
        change(e) {
            this.$emit("input", e.target.files[0]);
            this.updatePreview(e);
        },
        remove() {
            this.$emit("input", null);
            this.previewImg = null;
        },

        updatePreview(e) {
            const file = e.target.files[0];
            this.previewFilename = file.name;
            this.previewImg = URL.createObjectURL(file);
        }
    }
};
</script>
